import { AssessmentQuestion } from '../models/assessment';

export function isQuestionAnswered(question: AssessmentQuestion): boolean {
  return 'answer' in question && !!question.answer;
}
